<template>
    <form-group
        v-bind="form_group_props"
    >
        <template v-slot:read_only>
            <slot name="read_only">
                <input :disabled="true" :value="option_by_value(value)[labelField] || value" class="uk-width-1-1" />
            </slot>
        </template>
        <template v-slot:label><slot name="label"></slot></template>
        <template v-slot:hint><slot name="hint"></slot></template>
        <select
            ref="field"
            :id="identifier"
            :name="name"
            :disabled="disabled"
            @change="pick"
            :class="{ [`uk-width-${width}`]: true, [`uk-form-${size}`]: true }"
        >
            <option
                v-if="!!emptyLabel"
                :value="emptyValue"
                :selected="value === emptyValue"
                :disabled="!!required"
            >
                {{ emptyLabel }}
            </option>
            <option
                v-for="option in available_options"
                :key="option_value(option)"
                :value="option_value(option)"
                :selected="is_picked(option)"
                :disabled="!!option.deleted_at"
            >
                {{ option[labelField] || option }}
            </option>
        </select>
    </form-group>
</template>

<script>
import is_nibnut_component from "../mixins/IsNibnutComponent"

import FormGroup from "./FormGroup"

export default {
    name: "FormSelect",
    mixins: [is_nibnut_component],
    components: {
        FormGroup
    },
    methods: {
        option_value (option) {
            if(option[this.idField] !== undefined) return option[this.idField]
            return option
        },
        is_picked (option) {
            return `${this.option_value(option)}` === `${this.value}`
        },
        option_by_value (value) {
            return this.options.find(option => `${option[this.idField]}` === `${value}`) || {}
        },
        pick (event) {
            if(this.editable) {
                const option = this.option_by_value(event.target.value)
                if(!option[this.idField] && (option[this.idField] !== this.emptyValue)) option[this.idField] = this.emptyValue
                this.$emit("input", option[this.idField], this.name, option)
            }
        }
    },
    computed: {
        form_group_props () {
            return {
                id: this.id,
                name: this.name,
                value: this.value,
                required: this.required,
                editable: this.editable,
                error: this.error,
                waiting: this.saving,
                asRow: this.asRow
            }
        },
        available_options () {
            const options = this.options.slice()
            if(!this.option_by_value(this.value)) options.unshift({ [this.idField]: this.value, [this.labelField]: this.value })
            return options.filter(option => {
                return !option.deleted_at || this.is_picked(option)
            })
        }
    },
    props: {
        id: {
            type: String,
            validator: prop => !!prop
        },
        name: {
            type: String,
            validator: prop => !!prop,
            required: true
        },
        value: {
            default: null
        },
        emptyValue: {
            default: 0
        },
        emptyLabel: {
            type: String,
            default: "(Pick one)"
        },
        idField: {
            type: String,
            default: "id"
        },
        labelField: {
            type: String,
            default: "name"
        },
        options: {
            type: Array,
            default () {
                return []
            }
        },
        width: {
            type: String,
            default: "1-1"
        },
        size: {
            type: String,
            validator: prop => !!prop && !!prop.match(/^(small|normal|large)$/i),
            default: "normal"
        },
        required: {
            type: Boolean,
            required: true
        },
        editable: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        saving: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            default: ""
        },
        asRow: {
            type: Boolean,
            default: true
        }
    }
}
</script>
